// Goodbye.js
import React from 'react';

const Logout = () => {
    return (
        <div>
            <h1>Goodbye!</h1>
            <p>You have successfully logged out.</p>
        </div>
    );
};

export default Logout;
